import React, { Component } from "react";
import { Container } from "@material-ui/core";
import { connect } from "react-redux";
import * as actionsPresentacion from "../../../actions/nuevaPresentacion";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router";
import uploadService from "../../../services/upload-files";
import styles from "./styles";
import Presentacion from "../../Presentacion/Presentacion";
import * as actionsVentanaDialogo from "../../../actions/ventanaDialogo";
import {
    BotonPrincipal,
    BotonSecundario,
} from "../../common/UI/Personalizaciones/Boton";

class EditarPresentacion extends Component {
    componentDidMount = () => {
        window.scrollTo(0, 0);
        this.props.actualizarAtriutoPresentacion({
            mostrarBackdrop: true,
        });
        this.props.inicializarNuevaPresentacion();
        // this.props.buscarTiposPresentaciones();
        // const idPresentacion = this.props.match.params.idPresentacion;
        // this.props.recuperarPathTemporalParaArchivos(idPresentacion);
        // this.props.buscarDatosPresentacion(idPresentacion);

        const requestOne = this.props.buscarTiposPresentaciones();
       // const requestTwo = this.props.buscarTiposPrestaciones();
        //const requestThree = this.props.buscarTiposComprobantes();

        Promise.all([requestOne]).then(() => {
            const idPresentacion = this.props.match.params.idPresentacion;
            const idTipoPresentacion = this.props.match.params.idTipoPresentacion;
            this.props.buscarTiposPrestaciones(idTipoPresentacion);
            this.props.buscarTiposComprobantes(idTipoPresentacion);
            this.props.recuperarPathTemporalParaArchivos(idPresentacion);
            this.props.buscarDatosPresentacion(idPresentacion);
            

        });
    };

    mantenerseEnLaPagina(e) {
        var message =
            "Advertecia!\n\nEstá seguro de que desea abandonar la página actual? Perderá todo el contenido cargado hasta el momento.";
        e.returnValue = message;
        return message;
    }

    eliminarDatosCargados = () => {
        if (this.props.pathTemporal !== null) {
            uploadService.cancelarPresentacion(this.props.pathTemporal);
        }
    };

    accionVolver = () => {
        this.eliminarDatosCargados();
        this.props.history.push("/");
    };

    mostrarBotonEditar = () => {
        if (this.props.estado.descripcionWEB === "Observado") {
            return (
                <BotonPrincipal
                    variant="contained"
                    onClick={() =>
                        this.props.history.push(
                            "/editar/" + this.props.idPresentacion + "/" + this.props.idTipoPresentacion
                        )
                    }
                    className={this.props.classes.btnEnviar}
                >
                    Editar Presentación
                </BotonPrincipal>
            );
        }

        return null;
    };

    mostrarBotonRechazar = () => {
        console.log('entro ' + this.props.estado.descripcionWEB)
        if (this.props.estado.descripcionWEB === "En verificación" || this.props.estado.descripcionWEB === "Observado"){
            return ( 
                <BotonPrincipal
                    variant="contained"
                    onClick={
                        this.rechazar
                    }
                    className={this.props.classes.btnEnviar}
                >
                    Rechazar Presentación
                </BotonPrincipal>
            );
        }
        return null;
    }

    rechazarPresentacion = () => {
        console.log('entro a entroo');
        this.props
        .rechazarPresentacion(
            4
        )
        .then(() => {
            const ventanaConfig = {
                estaVisible: true,
                titulo: "Actualización exitosa",
                mensaje: `La presentación fue rechazada con éxito`,
                clickAceptar: () => {
                    this.props.actualizarAtriutoVentanaDialogo({
                        estaVisible: false,
                    });
                },
            };
            this.props.actualizarAtriutoVentanaDialogo(ventanaConfig);
        });

    }

    rechazar = () => {
        console.log('entro');
        const ventanaConfig = {
            estaVisible: true,
            titulo: "¿Esta seguro que desea rechazar la presentacion?",
            mensaje: "No se podra realizar ninguna acción",
            esAlerta: true,
            clickAceptar: this.rechazarPresentacion,
            clickCancelar: () =>
                this.props.actualizarAtriutoVentanaDialogo({
                    estaVisible: false,
                }),
        };
        this.props.actualizarAtriutoVentanaDialogo(ventanaConfig);
    }

    render() {
        const { classes, mostrarBackdrop } = this.props;
        return (
            <Container disableGutters={true}>
                <Presentacion />
                {!mostrarBackdrop && (
                    <Container
                        disableGutters={true}
                        className={classes.containerBotones}
                    >
                        <BotonSecundario
                            variant="outlined"
                            onClick={this.accionVolver}
                            className={classes.btnCancelar}
                        >
                            Volver
                        </BotonSecundario>
                        {this.mostrarBotonEditar()}
                        {this.mostrarBotonRechazar()}
                    </Container>
                )}
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    pathTemporal: state.nuevaPresentacionReducer.pathTemporal,
    emailResponsable: state.nuevaPresentacionReducer.emailResponsable,
    telefonoResponsable: state.nuevaPresentacionReducer.telefonoResponsable,
    idPresentacion: state.nuevaPresentacionReducer.idPresentacion,
    estado: state.nuevaPresentacionReducer.estado,
    mostrarBackdrop: state.nuevaPresentacionReducer.mostrarBackdrop,
    idTipoPresentacion: state.nuevaPresentacionReducer.tipoPresentacionSeleccionada,
});

const actionCreators = {
    inicializarNuevaPresentacion:
        actionsPresentacion.inicializarNuevaPresentacion,
    buscarTiposComprobantes: actionsPresentacion.buscarTiposComprobantesPresentacion,
    enviarPresentacionActualizada:
        actionsPresentacion.enviarPresentacionActualizada,
    buscarDatosPresentacion: actionsPresentacion.buscarDatosPresentacion,
    recuperarPathTemporalParaArchivos:
        actionsPresentacion.recuperarPathTemporalParaArchivos,
    buscarTiposPresentaciones: actionsPresentacion.buscarTiposPresentaciones,
    buscarTiposPrestaciones: actionsPresentacion.buscarTiposPrestacionesPresentacion,
    actualizarAtriutoPresentacion:
        actionsPresentacion.actualizarAtriutoPresentacion,
    actualizarAtriutoVentanaDialogo:
        actionsVentanaDialogo.actualizarAtriutoVentanaDialogo,
    rechazarPresentacion:
        actionsPresentacion.rechazarPresentacion,
    
};

export default connect(
    mapStateToProps,
    actionCreators
)(withStyles(styles)(withRouter(EditarPresentacion)));
